var OutsideClick = {
  mounted: function mounted() {
    if (typeof document !== 'undefined') {
      document.documentElement.addEventListener('click', this._handleOutsideClick);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.documentElement.removeEventListener('click', this._handleOutsideClick);
    }
  },
  methods: {
    _handleOutsideClick: function _handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        if (this.onOutsideClick) {
          this.onOutsideClick();
        }
      }
    },
  },
};

//

var script = {
  name: 'PtPagination',
  mixins: [OutsideClick],
  props: {
    totalRows: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: function () { return [10, 20, 50]; },
    },
    showNumber: {
      type: Boolean,
      default: true,
    },
  },
  data: function data() {
    return {
      current: this.currentPage,
      size: this.pageSize,
      numberOfPages: Math.ceil(this.totalRows / this.pageSize) || 1,
      showDropdown: false,
    };
  },
  computed: {
    pages: function pages() {
      if (this.numberOfPages < 5) {
        switch (this.numberOfPages) {
          case 3:
            return [2];
          case 4:
            return [2, 3];
          default:
            return true;
        }
      } else {
        switch (this.current) {
          case 1:
            return [this.current + 1, this.current + 2, this.current + 3];
          case 2:
            return [this.current, this.current + 1, this.current + 2];
          case this.numberOfPages - 1:
            return [this.current - 2, this.current - 1, this.current];
          case this.numberOfPages:
            return [this.current - 3, this.current - 2, this.current - 1];
          default:
            return [this.current - 1, this.current, this.current + 1];
        }
      }
    },
  },
  watch: {
    size: function size(newVal, oldVal) {
      this.onPageSizeChange(newVal);
    },
    currentPage: function currentPage(newVal) {
      this.current = newVal;
      this.numberOfPages = Math.ceil(this.totalRows / this.size) || 1;
    },
    pageSize: function pageSize(newVal) {
      this.size = newVal;
      this.current = 1;
      this.numberOfPages = Math.ceil(this.totalRows / this.size) || 1;
    },
    totalRows: function totalRows(newVal) {
      this.numberOfPages = Math.ceil(newVal / this.size) || 1;
    },
  },
  methods: {
    onPageSizeChange: function onPageSizeChange(pageSize) {
      this.size = pageSize;
      this.setPage(1, true);
    },
    onOutsideClick: function onOutsideClick() {
      if (this.showDropdown) {
        this.togglePerPageDropdown();
      }
    },
    setPage: function setPage(pageNo, hasPageSizeChanged) {
      if ( pageNo === void 0 ) pageNo = 1;
      if ( hasPageSizeChanged === void 0 ) hasPageSizeChanged = false;

      if (this.current === pageNo && !hasPageSizeChanged) {
        return;
      }

      this.current = pageNo;
      this.numberOfPages = Math.ceil(this.totalRows / this.size) || 1;
      this.$emit('page-changed', this.current, this.size);
    },
    setPageSize: function setPageSize(size) {
      this.size = size;
      this.togglePerPageDropdown();
    },
    togglePerPageDropdown: function togglePerPageDropdown() {
      this.showDropdown = !this.showDropdown;
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "pt-pagination-container" }, [
    _c("div", { staticClass: "pt-pagination-limit-container" }, [
      _c(
        "span",
        {
          staticClass: "cursor-pointer",
          on: { click: _vm.togglePerPageDropdown }
        },
        [
          _vm._v("\n        Show " + _vm._s(_vm.size) + " per page\n        "),
          _c("i", { staticClass: "fa fa-caret-down ml-2" })
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDropdown,
              expression: "showDropdown"
            }
          ],
          staticClass: "per_page_dropdown"
        },
        _vm._l(_vm.pageSizes, function(item) {
          return _c("li", { key: item }, [
            _c(
              "a",
              {
                staticClass: "item",
                class: { active: item === _vm.size },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault();
                    _vm.setPageSize(item);
                  }
                }
              },
              [
                _vm._v(
                  "\n            Show " + _vm._s(item) + " per page\n          "
                )
              ]
            )
          ])
        })
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pt-pagination-items-container" }, [
      _c(
        "ul",
        { staticClass: "pt-pagination-items" },
        [
          _c(
            "li",
            {
              staticClass: "pt-pagination-item__previous",
              class: [{ "pt-pagination-item-disabled": _vm.current === 1 }],
              on: {
                click: function($event) {
                  _vm.current > 1 ? _vm.setPage(_vm.current - 1) : null;
                }
              }
            },
            [_vm._v("Previous")]
          ),
          _vm._v(" "),
          _vm.showNumber
            ? [
                _c(
                  "li",
                  {
                    staticClass: "pt-pagination-item",
                    class: [{ "pt-pagination-item-active": _vm.current === 1 }],
                    on: {
                      click: function($event) {
                        _vm.setPage(1);
                      }
                    }
                  },
                  [_vm._v("1")]
                ),
                _vm._v(" "),
                _vm.current > 3 && _vm.numberOfPages > 5
                  ? _c("li", { staticClass: "pt-pagination-item-left-dot" }, [
                      _vm._v("...")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.pages, function(page, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "pt-pagination-item",
                      class: [
                        { "pt-pagination-item-active": _vm.current === page }
                      ],
                      on: {
                        click: function($event) {
                          _vm.setPage(page);
                        }
                      }
                    },
                    [_vm._v(_vm._s(page))]
                  )
                }),
                _vm._v(" "),
                _vm.numberOfPages !== 1 &&
                _vm.current < _vm.numberOfPages - 2 &&
                _vm.numberOfPages > 5
                  ? _c("li", { staticClass: "pt-pagination-item-right-dot" }, [
                      _vm._v("...")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.numberOfPages !== 1
                  ? _c(
                      "li",
                      {
                        staticClass: "pt-pagination-item",
                        class: [
                          {
                            "pt-pagination-item-active":
                              _vm.current === _vm.numberOfPages
                          }
                        ],
                        on: {
                          click: function($event) {
                            _vm.setPage(_vm.numberOfPages);
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.numberOfPages) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "pt-pagination-item__next",
              class: [
                {
                  "pt-pagination-item-disabled":
                    _vm.current === _vm.numberOfPages
                }
              ],
              on: {
                click: function($event) {
                  _vm.current < _vm.numberOfPages
                    ? _vm.setPage(_vm.current + 1)
                    : null;
                }
              }
            },
            [_vm._v("Next")]
          )
        ],
        2
      )
    ])
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Pagination = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { Pagination as PtPagination };
